<template>
    <v-container grid-list-md fluid class="pb-0 mb-0">
        <v-card class="default_card large mx-0 my-2 pa-2 fill-height sticky-card" elevation="0">
            <v-row no-gutters>
                <v-col :cols="enablePublish || enablehUnpublish ? '8' : '10'">
                    <v-btn-back class="mr-4" @click.stop="warnUser()"> </v-btn-back>
                    <span class="headline">
                        {{ title }}
                    </span>
                </v-col>
                <v-col
                    :cols="enablePublish || enablehUnpublish ? '4' : '2'"
                    class="d-flex justify-end"
                >
                    <v-btn
                        rounded
                        elevation="0"
                        class="ml-2"
                        @click="upload()"
                        :class="{ 'animate-attention': !isDisabled }"
                        :disabled="isDisabled"
                        data-cy="WordingAnalysisEdition-creer"
                        ref="leBoutton"
                    >
                        {{ patternId ? "Modifier" : "Créer" }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <div style="height: 75vh; overflow: auto">
            <v-card class="scrolled-card">
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-start align-center pb-2">
                        <h2>{{ $t("wording-analysis.conditions") }}</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters v-for="(cont, index) of specs.patternSpec" :key="index">
                    <v-col cols="1" class="d-flex align-center justify-center">
                        {{ index !== 0 ? "ET" : "SI" }}
                    </v-col>
                    <v-col cols="2" class="py-2">
                        <v-select-filled
                            v-model="cont.operator"
                            :items="operators"
                            outlined
                            :hide-details="true"
                            :readonly="readonly"
                            data-cy="WordingAnalysisEdition-contOperator"
                            density="compact"
                            item-title="text"
                            item-value="value"
                        />
                    </v-col>
                    <v-col cols="8" class="py-2 pl-2">
                        <v-combobox-filled
                            v-model="cont.words"
                            :label="$t('wording-analysis.un-de-ces-mots')"
                            multiple
                            chips
                            no-filter
                            hide-details
                            item-disabled
                            :readonly="readonly"
                            data-cy="WordingAnalysisEdition-remplace"
                        />
                    </v-col>
                    <v-col col="1" class="d-flex align-center justify-space-between ml-2">
                        <v-btn-trash
                            v-if="specs.patternSpec.length > 1"
                            size="x-small"
                            @click="removeCondition(index)"
                            :disabled="readonly"
                        />
                        <v-btn
                            v-if="index + 1 === specs.patternSpec.length"
                            size="x-small"
                            @click="addCondition()"
                            :disabled="readonly"
                            icon="$add"
                        >
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-2 justify-center">
                    <v-col cols="12">
                        <v-divider />
                    </v-col>
                    <v-col cols="5" class="d-flex align-center">
                        <v-text-field-filled
                            outlined
                            dense
                            hide-details
                            :label="$t('wording-analysis.montant-min')"
                            :disabled="!defineMinAmount"
                            :readonly="readonly"
                            v-model="minAmount"
                        />
                        <v-checkbox
                            class="mx-2"
                            color="green"
                            v-model="defineMinAmount"
                            :readonly="readonly"
                        />
                    </v-col>
                    <v-col cols="5" class="d-flex align-center">
                        <v-text-field-filled
                            outlined
                            dense
                            hide-details
                            :label="$t('wording-analysis.montant-max')"
                            :disabled="!defineMaxAmount"
                            :readonly="readonly"
                            v-model="maxAmount"
                        />
                        <v-checkbox
                            class="mx-2"
                            color="green"
                            v-model="defineMaxAmount"
                            :readonly="readonly"
                        />
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="scrolled-card">
                <v-row no-gutters class="mt-2">
                    <v-col cols="12" class="d-flex justify-start align-center pb-2">
                        <h2>{{ $t("wording-analysis.modification-libelle") }}</h2>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field-filled
                            v-model="specs.rules.outputWording"
                            :label="$t('wording-analysis.libelle-remp')"
                            outlined
                            hide-details
                            :readonly="readonly"
                            data-cy="WordingAnalysisEdition-specsOutputWording"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center">
                    <v-col cols="11">
                        <v-row no-gutters>
                            <v-col cols="12" class="title pt-4"> Compte tiers </v-col>
                            <v-col cols="2" class="d-flex align-center">
                                <v-switch
                                    v-model="specs.rules.thirdPartyOnly"
                                    :label="$t('wording-analysis.activer')"
                                    @click="toggleRule('thirdPartyOnly')"
                                    :readonly="readonly"
                                    data-cy="WordingAnalysisEdition-specsThirdPartyOnly"
                                />
                            </v-col>
                            <v-col
                                cols="5"
                                v-if="assignedCompanyCount !== 1 || !uniqueAssignedCompanyId"
                            >
                                <AccountableAccount
                                    v-show="true"
                                    :showLabel="true"
                                    :label="' '"
                                    :showValidation="false"
                                    :showDescription="true"
                                    :inAccountableAccounts="accountableAccountsCFSTF"
                                    :inAccountableAccount="specs.rules.thirdPartyAccountableAccount"
                                    :disabled="!specs.rules.thirdPartyOnly || readonly"
                                    :hideDetails="true"
                                    @select-accountableAccount="selectThirdPartyAccountableAccount"
                                    :defineThirdParty="true"
                                    data-cy="WordingAnalysisEdition-accountableAccountSpecsThirdPartyOnly"
                                />
                            </v-col>
                            <v-col cols="5" v-else>
                                <AccountableAccount
                                    v-show="true"
                                    :showLabel="true"
                                    :label="' '"
                                    :showValidation="false"
                                    :showDescription="true"
                                    :companyId="uniqueAssignedCompanyId"
                                    :thirdParty="
                                        specs.thirdParty ||
                                        specs.thirdPartyCompany ||
                                        specs.thirdPartyUser
                                    "
                                    :inAccountableAccounts="accountableAccountsCFSTF"
                                    :inAccountableAccount="specs.rules.thirdPartyAccountableAccount"
                                    :disabled="!specs.rules.thirdPartyOnly || readonly"
                                    :hideDetails="true"
                                    @select-accountableAccount="selectThirdPartyAccountableAccount"
                                    :defineThirdParty="true"
                                    data-cy="WordingAnalysisEdition-accountableAccountSpecsThirdPartyOnly"
                                />
                            </v-col>
                            <v-col cols="5" class="d-flex align-center pl-2">
                                <!-- ThirdPartyCompany -->
                                <v-text-field-filled
                                    readonly
                                    outlined
                                    :key="specs.id"
                                    :label="$t('wording-analysis.tiers')"
                                    hide-details
                                    disabled
                                    :model-value="thirdPartyTitle"
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="12" class="title pt-4">
                                {{ $t("wording-analysis.affectation") }}
                            </v-col>
                            <v-col cols="2" class="d-flex align-center">
                                <v-switch
                                    v-model="specs.rules.withoutInvoice"
                                    :label="$t('wording-analysis.activer')"
                                    @click="toggleRule('withoutInvoice')"
                                    :readonly="readonly"
                                    data-cy="WordingAnalysisEdition-specsWithoutInvoice"
                                />
                            </v-col>
                            <v-col :cols="displayVatRate ? 5 : 10">
                                <AccountableAccount
                                    v-show="true"
                                    :showLabel="true"
                                    :showValidation="false"
                                    :showDescription="true"
                                    :companyId="uniqueAssignedCompanyId"
                                    :inAccountableAccounts="purchaseAndSalesAAs"
                                    :inAccountableAccount="specs.rules.accountableAccount"
                                    :disabled="!specs.rules.withoutInvoice || readonly"
                                    :hideDetails="true"
                                    @select-accountableAccount="selectAccountableAccount"
                                    data-cy="WordingAnalysisEdition-accountableAccountSpecsWithoutInvoice"
                                />
                            </v-col>
                            <v-col cols="5" class="d-flex align-center pl-2" v-if="displayVatRate">
                                <v-select-filled
                                    v-model="vat"
                                    :items="vats"
                                    label="Le taux de TVA à appliquer"
                                    return-object
                                    hide-details
                                />
                            </v-col>

                            <v-col cols="12" class="title pt-4">
                                {{ $t("wording-analysis.sans-facture") }}
                            </v-col>
                            <v-col cols="2" class="d-flex align-center">
                                <v-switch
                                    v-model="specs.rules.withoutInvoiceWithThirdParty"
                                    :label="$t('wording-analysis.activer')"
                                    @click="toggleRule('withoutInvoiceWithThirdParty')"
                                    :readonly="readonly"
                                    data-cy="WordingAnalysisEdition-specsWithoutInvoiceWithThirdParty"
                                />
                            </v-col>
                            <v-col cols="5">
                                <AccountableAccount
                                    v-show="true"
                                    :showLabel="true"
                                    :showValidation="false"
                                    :showDescription="true"
                                    :companyId="uniqueAssignedCompanyId"
                                    :inAccountableAccounts="purchaseAndSalesAAs"
                                    :inAccountableAccount="specs.rules.accountableAccount"
                                    :disabled="
                                        !specs.rules.withoutInvoiceWithThirdParty || readonly
                                    "
                                    :hideDetails="true"
                                    @select-accountableAccount="selectAccountableAccount"
                                    data-cy="WordingAnalysisEdition-accountableAccountSpecsWithoutInvoiceWithThirdParty"
                                />
                            </v-col>
                            <v-col cols="5" class="d-flex align-center pl-2">
                                <!-- ThirdPartyCompany -->
                                <v-text-field-filled
                                    readonly
                                    outlined
                                    :label="$t('wording-analysis.societe-tiers')"
                                    hide-details
                                    :disabled="!thirdPartyCompanyIsRequired"
                                    @click="dialogSelectCompany = !dialogSelectCompany"
                                    data-cy="WordingAnalysisEdition-societeTiers"
                                    :model-value="
                                        specs.thirdPartyCompany && specs.thirdPartyCompany.name
                                            ? specs.thirdPartyCompany.name
                                            : ''
                                    "
                                    density="compact"
                                />
                            </v-col>

                            <v-col cols="12" class="title pt-4">
                                {{ $t("wording-analysis.encaissement") }}</v-col
                            >
                            <v-col cols="2" class="d-flex align-center">
                                <v-switch
                                    v-model="specs.rules.salesInvoiceAuto"
                                    :label="$t('wording-analysis.activer')"
                                    @click="toggleRule('salesInvoiceAuto')"
                                    :readonly="readonly"
                                    data-cy="WordingAnalysisEdition-specsSalesInvoiceAuto"
                                />
                            </v-col>
                            <v-col cols="10">
                                <AccountableAccount
                                    v-show="true"
                                    :showLabel="true"
                                    :showValidation="false"
                                    :showDescription="true"
                                    :companyId="uniqueAssignedCompanyId"
                                    :inAccountableAccounts="salesAAs"
                                    :inAccountableAccount="specs.rules.accountableAccount"
                                    :disabled="!specs.rules.salesInvoiceAuto || readonly"
                                    :hideDetails="true"
                                    @select-accountableAccount="selectAccountableAccount"
                                    data-cy="WordingAnalysisEdition-accountableAccountSpecsSalesInvoiceAuto"
                                />
                            </v-col>
                            <v-col cols="12" class="title pt-4"> Z de caisse </v-col>
                            <v-col cols="2" class="d-flex align-center">
                                <v-switch
                                    v-model="specs.rules.zTillReceipt"
                                    :label="$t('wording-analysis.activer')"
                                    @click="toggleRule('ztillReceipt')"
                                    :readonly="readonly"
                                    data-cy="WordingAnalysisEdition-specsZTillReceipt"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters class="px-3 pt-2">
                    <v-col cols="12" class="d-flex justify-start align-center pb-2">
                        <h2>{{ $t("wording-analysis.etiquettes") }}</h2>
                    </v-col>
                    <v-col cols="12" class="d-flex align-center">
                        <v-combobox-filled
                            v-model="specs.rules.tags"
                            multiple
                            density="compact"
                            chips
                            closable-chips
                            item-disabled
                        />
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="scrolled-card">
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-start align-center pb-2">
                        <h2>{{ $t("wording-analysis.test-libelle") }}</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center">
                    <v-col cols="12" class="d-flex align-center">
                        <div style="min-width: 40px">
                            <v-icon
                                :color="testResult ? 'green' : 'red'"
                                v-if="wordingTest && !regexEmpty"
                                >{{ testResult ? "$fa-thumbs-up" : "$fa-thumbs-down" }}
                            </v-icon>
                        </div>
                        <v-text-field-filled
                            v-model="wordingTest"
                            outlined
                            hide-details
                            label="Test"
                            data-cy="WordingAnalysisEdition-test"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center mt-2">
                    <v-col cols="12" class="d-flex justify-start align-center py-2">
                        <h2>{{ $t("wording-analysis.simulation") }}</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-2">
                    <v-col cols="8" class="d-flex">
                        <div style="min-width: 40px"></div>
                        <v-select-filled
                            v-model="scopedCompanyId"
                            :items="scopedCompanies"
                            item-value="id"
                            outlined
                            :hide-details="false"
                            :readonly="readonly"
                            data-cy="WordingAnalysisEdition-scopedCompanyId"
                            density="compact"
                            class="mr-3"
                            :item-title="(item) => item.name"
                        />
                        <v-btn
                            class="mx-3 mt-2"
                            rounded
                            elevation="0"
                            :disabled="regexEmpty || !scopedCompanyId"
                            @click="simulatingWordingBTAnalysis(wordingTest)"
                            data-cy="WordingAnalysisEdition-simulation"
                            size="small"
                        >
                            {{ $t("wording-analysis.simuler") }}
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-start">
                        <v-tooltip v-if="displaySimulationResult" location="bottom">
                            <!-- <v-tooltip v-if="true" location="bottom"> -->
                            <template v-slot:activator="{ props }">
                                <div v-bind="props">
                                    <v-btn
                                        rounded
                                        color="primary"
                                        class="mx-3 mt-2"
                                        elevation="0"
                                        :disabled="
                                            readonly ||
                                            !simulateWordingBTAnalysis ||
                                            simulateWordingBTAnalysis.length === 0 ||
                                            isDisabled
                                        "
                                        @click="applySimulationDialog = true"
                                        size="small"
                                    >
                                        {{ $t("wording-analysis.appliquer") }}
                                    </v-btn>
                                </div>
                            </template>
                            <span style="font-weight: bold"
                                >{{ $t("wording-analysis.appliquer-regle") }}
                            </span>
                            <span
                                style="display: block; font-style: italic"
                                v-if="
                                    simulateWordingBTAnalysis &&
                                    simulateWordingBTAnalysis.length === 0
                                "
                                >{{ $t("wording-analysis.aucun-releve") }}</span
                            >
                            <span
                                style="display: block; font-style: italic"
                                v-else-if="isDisabled"
                                >{{ $t("wording-analysis.donner-regle") }}</span
                            >
                        </v-tooltip>

                        <v-tooltip
                            v-if="scopedCompanies && scopedCompanies.length > 1"
                            location="bottom"
                        >
                            <!-- <v-tooltip v-if="true" location="bottom"> -->
                            <template v-slot:activator="{ props }">
                                <div v-bind="props" class="pl-1">
                                    <v-btn
                                        rounded
                                        color="primary"
                                        class="ml-3 mt-2"
                                        elevation="0"
                                        :disabled="readonly || isDisabled"
                                        @click="applyOnCompaniesDialog = true"
                                        size="small"
                                        >{{ $t("wording-analysis.appliquer-societes") }}
                                    </v-btn>
                                </div>
                            </template>
                            <span style="font-weight: bold"
                                >{{
                                    $t("wording-analysis.appliquer-societes", {
                                        count: scopedCompanies.length,
                                    })
                                }}
                            </span>

                            <span style="display: block; font-style: italic" v-if="isDisabled">{{
                                $t("wording-analysis.pensez")
                            }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-2" v-if="displaySimulationResult">
                    <v-col cols="12" class="d-flex justify-start align-center pb-2">
                        <h3>{{ $t("wording-analysis.resultats") }}</h3>
                    </v-col>
                    <v-col cols="12" class="pt-2 d-flex justify-center">
                        <v-data-table
                            :headers="headers"
                            :items="formatedSimulateWordingBTAnalysis"
                            :items-per-page="20"
                            :loading="simulationLoading"
                            hide-default-header
                            class="elevation-0 table"
                            density="compact"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td>
                                        {{
                                            props.item.wordingDisplay || props.item.wordingOriginal
                                        }}
                                    </td>
                                    <td>{{ props.item.amount }}</td>
                                    <td class="text-center">{{ props.item.date }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card>
            <ScopeManager
                ref="scopeManager"
                v-model="scopeSync"
                v-model:id="scopeId"
                v-model:name="scopeName"
                :readonly="readonly"
                :initialCompany="initialCompany"
                :returnScopedCompanies="true"
                @scopedCompanies="onScopedCompaniesChanged"
            />
        </div>
        <v-snackbar v-model="alertApplyingSimulationSuccess" color="success">
            {{ $t("wording-analysis.modifs-appliques") }}

            <template v-slot:actions>
                <v-btn
                    color="white"
                    timeout="6000"
                    @click="alertApplyingSimulationSuccess = false"
                    variant="text"
                >
                    {{ $t("wording-analysis.fermer") }}
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="snackbarActive">
            {{ snackbarText }}
            <template v-slot:actions>
                <v-btn @click="snackbarActive = false" variant="text">
                    {{ $t("wording-analysis.fermer") }}
                </v-btn>
            </template>
        </v-snackbar>
        <!-- ThirdPartyCompany -->
        <oss-dialog
            v-model="dialogSelectCompany"
            :title="$t('wording-analysis.choissiz-societe-tiers')"
            v-if="dialogSelectCompany"
            width="800px"
        >
            <company-table
                :showGenericCompany="false"
                :showNewCompanies="true"
                :show-customer-companies="
                    uniqueAssignedCompanyId &&
                    specs.rules &&
                    specs.rules.accountableAccount &&
                    specs.rules.accountableAccount.name &&
                    specs.rules.accountableAccount.name.startsWith('7')
                "
                :show-supplier-companies="
                    uniqueAssignedCompanyId &&
                    specs.rules &&
                    specs.rules.accountableAccount &&
                    specs.rules.accountableAccount.name &&
                    specs.rules.accountableAccount.name.startsWith('6')
                "
                :showExistingCompanies="!uniqueAssignedCompanyId"
                :parent-company-id="uniqueAssignedCompanyId"
                :wizardMode="true"
                @select-company="companySelected"
            >
            </company-table>
        </oss-dialog>

        <oss-dialog
            v-model="applySimulationDialog"
            :title="$t('wording-analysis.appliquer-modifs')"
            @valid="applyingSimulation()"
            :validLoading="applySimulationDialogLoading"
            width="800px"
        >
            <h4 class="text-center">
                {{ confirmationMessage }}
            </h4>
        </oss-dialog>

        <oss-dialog
            v-model="areYouSureDialog"
            data-cy="oss-dialog-are-you-sure"
            :title="$t('wording-analysis.sans-enregistrer')"
            width="800px"
        >
            <template v-slot:actions>
                <v-row no-gutters style="min-width: 30vw">
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="onYesDialog"
                            data-cy="clicking-yes-button"
                            size="x-large"
                            >{{ $t("wording-analysis.oui") }}</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary rounded block @click="onNoDialog" size="x-large">{{
                            $t("wording-analysis.non")
                        }}</v-btn-primary>
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import gql from "graphql-tag";
import { User } from "../../store/store";
import { Apollo } from "@/decorators";

import AccountableAccount from "../AccountableAccount.vue";
import CompanyTableComponent from "./CompaniesTable.vue";
import ScopeManager from "../companyScope/ScopeManager.vue";

import BANK_WORDING_PATTERN from "../../graphql/BankTransactionWordingPattern.gql";
import DEFAULT_ACCOUNTABLE_ACCOUNTS from "../../graphql/accountableAccount/DefaultAccountableAccounts.gql";
import COMPANY_ACCOUNTABLE_ACCOUNT_TABLE from "../../graphql/accountableAccount/companyAccountableAccountTable.gql";

import { createCompany } from "../../services/companyServices";
import moment from "moment-timezone";
import { getUserDisplayName } from "../../services/userServices";
import { vatListWordingAnalysis } from "@/services/vatServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Watch, Model, Ref } from "vue-facing-decorator";
import base64url from "base64url";

interface CompanyScope {
    id: string;
}
@Component({
    components: {
        AccountableAccount,
        companyTable: CompanyTableComponent,
        ScopeManager,
    },
    emits: ["upserted"],
})
export class WordingAnalysisEdition extends Vue {
    @Model({ type: Object as () => CompanyScope, name: "companyScope" })
    readonly scopeSync!: CompanyScope;
    @Prop({ default: null }) companyId: string | null;
    @Prop({ default: null }) bankTransaction_64: string | null;
    @Prop({ default: null }) bankTransaction: string | null;

    @Ref() readonly scopeManager!: InstanceType<typeof ScopeManager>;
    @Ref() readonly leBoutton!: InstanceType<typeof HTMLButtonElement>;

    apolloFinished = false;
    defineMinAmount = false;
    minAmount = 0;

    dialogSelectCompany = false;

    defineMaxAmount = false;
    maxAmount = 0;

    accountableAccountDialog = true;

    withoutInvoiceAccountableAccount = null;

    searchCompany = "";

    allAccountingCompany = true;

    alertApplyingSimulationSuccess = false;

    wordingTest = "";

    scopeName = "";
    scopeId_ = "";

    get confirmationMessage(): string {
        return this.$t("wording-analysis.etes-vous-sur", this.simulateWordingBTAnalysis.length);
    }

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get forClient() {
        return this.$store.state.selected_company?.id;
    }

    get accountingFirmId() {
        if (this.forClient) {
            return this.$store.state.selected_company?.id;
        } else return this.$store.state.user?.company?.id;
    }

    initialCompany = null;

    get bankTransaction_() {
        if (this.bankTransaction_64) {
            return JSON.parse(base64url.decode(this.bankTransaction_64));
        } else return null;
    }

    fillWithBankTransaction() {
        const bankTransaction = this.bankTransaction_;
        if (bankTransaction) {
            this.allAccountingCompany = false;
            if (this.$store.state.lastSelected_company?.id) {
                this.initialCompany = this.$store.state.lastSelected_company;
            } else if (this.$store.state.selected_company?.id) {
                this.initialCompany = this.$store.state.selected_company;
            }
            if (bankTransaction.wordingDisplay || bankTransaction.wordingOriginal) {
                this.wordingTest =
                    bankTransaction.wordingDisplay || bankTransaction.wordingOriginal;
            }
            if (bankTransaction.wordingLight) {
                const words = bankTransaction.wordingLight.split(" ");
                const uniqueWords = [];
                for (const word of words) {
                    if (!word) {
                        continue;
                    }
                    if (word === "-") {
                        continue;
                    }
                    if (uniqueWords.indexOf(word) === -1) {
                        uniqueWords.push(word);
                    }
                }
                const originaWordings = bankTransaction.wordingOriginal
                    ? bankTransaction.wordingOriginal.split(" ")
                    : [];
                for (const word of uniqueWords) {
                    const operator = originaWordings.find((w) => w.toLowerCase() === word)
                        ? "equal"
                        : "contains";
                    this.specs.patternSpec.push({
                        operator,
                        words: [word],
                    });
                }
            }
            if (bankTransaction.accountingLines?.length === 2) {
                for (const accountingLine of bankTransaction.accountingLines) {
                    if (accountingLine.accountableAccount.name?.startsWith("512")) {
                        continue;
                    }
                    if (!accountingLine.accountableAccount?.name) {
                        continue;
                    }
                    if (
                        accountingLine.accountableAccount.name.startsWith("6") ||
                        accountingLine.accountableAccount.name.startsWith("7")
                    ) {
                        this.specs.rules.accountableAccount = accountingLine.accountableAccount;
                        this.specs.rules.withoutInvoice = true;
                    } else {
                        this.specs.rules.thirdPartyOnly = true;
                        this.specs.rules.thirdPartyAccountableAccount =
                            accountingLine.accountableAccount;
                        if (accountingLine.thirdPartyCompany) {
                            this.specs.thirdPartyCompany = accountingLine.thirdPartyCompany;
                        } else if (accountingLine.user) {
                            this.specs.thirdPartyUser = accountingLine.user;
                        }
                    }
                }
            }
        }
        if (!this.specs.patternSpec) {
            this.specs.patternSpec = [];
        }
        if (!this.specs.patternSpec.length) {
            this.specs.patternSpec.push({
                operator: "equal",
                words: [],
            });
        }
    }

    fillForClient() {
        if (this.forClient) {
            this.allAccountingCompany = false;
            this.initialCompany = this.$store.state.selected_company;
        }
    }

    beforeMount() {
        this.fillWithBankTransaction();
        this.fillForClient();

        if (!this.isRootProfile) {
            this.allAccountingCompany = false;
        }
    }

    snackbarText = "";

    snackbarActive = false;

    scopeSharingStatus = "";

    validationForAllAccountingCompany = false;

    displaySimulationResult = false;

    simulationLoading = false;

    applySimulationDialog = false;
    applySimulationDialogLoading = false;

    applyOnCompaniesDialog = false;

    displayThirdParty = "";

    initialSpecs = null;

    transactionTypes = [
        { text: "Debit", value: "debit" },
        { text: "Credit", value: "credit" },
        { text: "Debit et Credit", value: "" },
    ];

    operators = [
        { text: "Egal à", value: "equal" },
        { text: "Contient", value: "contains" },
        { text: "Démarre par", value: "startsWith" },
        { text: "Fini par", value: "endsWith" },
    ];

    headers = [{ value: "name" }, { value: "amount" }, { value: "date" }];

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    get patternId() {
        if (this.$route.params.id) {
            return this.$route.params.id;
        }
        return "";
    }

    get title() {
        let title = this.$t("wording-analysis.analyse-de-libelle");
        if (this.name) {
            title += " : " + this.name;
        }
        return title;
    }

    get regExGenerated() {
        // let regEx = "^"
        this.simulateWordingBTAnalysis = [];
        this.displaySimulationResult = false;
        let regEx = "";
        if (this.specs.patternSpec?.length) {
            for (const condition of this.specs.patternSpec) {
                if (condition.words?.length) {
                    let words = condition.words.join("|");
                    words = words.replace(/\(/g, "\\(");
                    words = words.replace(/\)/g, "\\)");
                    words = words.replace(/\./, "\\.");
                    if (condition.operator === "equal") {
                        regEx += "(?=.*\\b(" + words + ")\\b)";
                    } else if (condition.operator === "contains") {
                        regEx += "(?=.*(" + words + "))";
                    } else if (condition.operator === "startsWith") {
                        regEx += "(?=.*\\b(" + words + "))";
                    } else if (condition.operator === "endsWith") {
                        regEx += "(?=.*(" + words + ")\\b)";
                    }
                }
            }
            regEx += ".*";
        }

        // return regEx + "$"
        return regEx;
    }

    get regexEmpty() {
        if (this.regExGenerated === ".*") {
            return true;
        }
        return false;
    }

    get name() {
        let regEx = "";
        if (this.specs?.patternSpec?.length) {
            for (const condition of this.specs.patternSpec) {
                if (regEx) {
                    regEx += " et ";
                }
                if (condition.operator === "contains" || condition.operator === "endsWith") {
                    regEx += "xx";
                }
                if (condition.words.length === 1) {
                    regEx += condition.words[0];
                } else {
                    regEx += "(" + condition.words.join(" ou ") + ")";
                }
                if (condition.operator === "contains" || condition.operator === "startsWith") {
                    regEx += "xx";
                }
            }
        }
        return regEx;
    }

    get currentUser(): User {
        return this.$store?.state.user;
    }

    get profile() {
        return this.$store.state.user.profile;
    }

    get clientCompanies() {
        return this.currentUser?.allAvailableCompanies;
    }

    scopedCompanyId = null;
    scopedCompanies = this.clientCompanies || [];

    get clientCompaniesIds() {
        return this.clientCompanies.filter((cc) => !!cc?.id).map((cc) => cc?.id);
    }

    get assignedCompanyCount() {
        return this.scopedCompanies?.length;
    }

    get systemTaxes() {
        return ["BIC", "BNC", "RF"];
    }

    aasWithTPC = ["401000", "401100", "401700", "404000", "404100", "404700", "411000", "411100"];

    get thirdPartyCompanyIsRequired() {
        if (this.specs?.rules?.thirdPartyOnly) {
            if (this.specs.rules.thirdPartyAccountableAccount?.name) {
                if (
                    this.aasWithTPC.indexOf(
                        this.specs.rules.thirdPartyAccountableAccount.name.substring(0, 6),
                    ) !== -1
                ) {
                    return true;
                }
            }
            return false;
        }
        if (this.specs?.rules.withoutInvoiceWithThirdParty) {
            return true;
        }
        return false;
    }

    aasWithUser = ["421000", "425000", "455000", "455100", "467000", "467100", "108000"];

    get thirdPartyUserIsRequired() {
        if (this.specs?.rules?.thirdPartyOnly) {
            if (this.specs.rules?.thirdPartyAccountableAccount?.name) {
                if (
                    this.aasWithUser.indexOf(
                        this.specs.rules.thirdPartyAccountableAccount.name.substring(0, 6),
                    ) !== -1
                ) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    /**
     * Defines wether the create/update button is disabled or not. It is disabled if:
     * - The profile is readonly
     * - There is no pattern
     * - There is no rule
     * - There is no accountable account
     * - There is no third party company
     * - There is no third party user
     * - There is no scopeId
     * - The profile is not for a client
     * @returns boolean
     */
    get isDisabled(): boolean {
        if (this.readonly) {
            return true;
        }
        let count = 0;
        for (const patternSpec of this.specs.patternSpec) {
            if (patternSpec.words?.length) {
                count++;
            }
        }
        if (!count) {
            return true;
        }

        if (!this.specs.rules) {
            return true;
        }
        if (
            !this.specs.rules.thirdPartyOnly &&
            !this.specs.rules.withoutInvoice &&
            !this.specs.rules.withoutInvoiceWithThirdParty &&
            !this.specs.rules.salesInvoiceAuto &&
            !this.specs.rules.zTillReceipt
        ) {
            return true;
        }

        if (
            (this.specs.rules.withoutInvoice ||
                this.specs.rules.withoutInvoiceWithThirdParty ||
                this.specs.rules.salesInvoiceAuto) &&
            !this.specs.rules?.accountableAccount?.name
        ) {
            return true;
        }

        if (
            this.thirdPartyCompanyIsRequired &&
            (!this.specs.thirdPartyCompany || !this.specs.thirdPartyCompany.name)
        ) {
            return true;
        }
        if (
            this.thirdPartyUserIsRequired &&
            (!this.specs.thirdPartyUser || !this.specs.thirdPartyUser.id)
        ) {
            return true;
        }
        if (!this.scopeId && !this.forClient) {
            return true;
        }
        return false;
    }

    get displayVatRate() {
        return this.specs?.rules?.accountableAccount?.name?.startsWith("6");
    }

    get testResult() {
        if (this.wordingTest && this.regExGenerated) {
            const regEx = new RegExp(this.regExGenerated, "i");
            return regEx.test(this.wordingTest);
        }
        return false;
    }

    get enablePublish() {
        if (this.isRootProfile) {
            if (this.scopeSharingStatus === "PENDING_VALIDATION") {
                return true;
            }
        }
        return false;
    }

    get enablehUnpublish() {
        if (this.isRootProfile) {
            if (this.scopeSharingStatus === "VALIDATE" && this.allAccountingCompany) {
                return true;
            }
        }
        return false;
    }

    get uniqueAssignedCompanyId() {
        if (this.scopedCompanies?.length === 1) {
            return this.scopedCompanies[0].id;
        }
        return null;
    }

    vat = null;

    get vats() {
        return vatListWordingAnalysis;
    }

    @Watch("vat")
    onVatChanged() {
        if (!this.vat) {
            this.specs.rules.vatRate = null;
            this.specs.rules.vatType = null;
        } else {
            this.specs.rules.vatRate = this.vat.vatRate;
            this.specs.rules.vatType = this.vat.vatType;
        }
    }

    @Watch("assignedCompanyCount")
    onAssignedCompanyCountChanged(value, prevValue) {
        if (value !== 1) {
            if (this.specs.thirdPartyUser?.id) {
                this.resetThirdPartyUser();
                this.resetThirdPartyAccountableAccount();
            }
            if (this.specs.thirdPartyCompany?.id) {
                if (this.specs.thirdPartyCompany.parentCompany) {
                    this.resetThirdPartyCompany();
                    this.resetThirdPartyAccountableAccount();
                }
            }
        }
    }

    removeCondition(index) {
        this.specs.patternSpec.splice(index, 1);
    }

    selectAccountableAccount(data) {
        if (data.accountableAccount?.id) {
            delete data.accountableAccount.id;
        }
        this.specs.rules.accountableAccount = data.accountableAccount;
    }

    selectThirdPartyAccountableAccount(data) {
        if (data.accountableAccount?.id) {
            delete data.accountableAccount.id;
        }
        this.specs.rules.thirdPartyAccountableAccount = data.accountableAccount;
        // this.specs.thirdParty = data.thirdParty
        if (data.thirdParty) {
            if (data.thirdParty.type === "company") {
                this.specs.thirdPartyCompany = data.thirdParty;
            } else if (data.thirdParty.type === "user") {
                this.specs.thirdPartyUser = data.thirdParty;
            }
        }
        if (!this.thirdPartyCompanyIsRequired) {
            this.resetThirdPartyCompany();
        }
        if (!this.thirdPartyUserIsRequired) {
            this.resetThirdPartyUser();
        }
    }

    resetAccountableAccount(specs = undefined) {
        const localSpecs = specs || this.specs;
        localSpecs.rules.accountableAccount = null;
        // {
        //     id: "",
        //     name: "",
        // subAccountableAccountOf: null
        // }
    }

    resetThirdPartyAccountableAccount(specs: any = undefined) {
        const localSpecs = specs || this.specs;
        localSpecs.thirdPartyAccountableAccount = null;
        // {
        //     id: "",
        //     name: "",
        // subAccountableAccountOf: null
        // }
    }

    resetThirdPartyCompany(specs: any = undefined) {
        const localSpecs = specs || this.specs;
        localSpecs.thirdPartyCompany = {
            id: "",
            name: "",
            parentCompany: null,
        };
    }

    resetThirdPartyUser(specs: any = undefined) {
        const localSpecs = specs || this.specs;
        localSpecs.thirdPartyUser = {
            id: "",
            firstname: "",
            lastname: "",
        };
    }

    readonlyTemporaire = false;

    get readonly() {
        if (this.readonlyTemporaire) {
            return true;
        }
        if (!this.profile.configuration.accountingRule.write) {
            return true;
        }
        return false;
    }

    async upload() {
        if (this.thirdPartyCompanyIsRequired && !this.specs.thirdPartyCompany?.id) {
            if (this.specs.thirdPartyCompany.name) {
                this.specs.thirdPartyCompany.id = await createCompany(
                    this.$apollo,
                    this.specs.thirdPartyCompany,
                );
            } else {
                console.error("third party company undefined");
                return;
            }
        }
        if (Number(this.minAmount) && Number(this.maxAmount) && this.minAmount > this.maxAmount) {
            this.snackbarText = this.$t("wording-analysis.min-max-amount-error");
            this.snackbarActive = true;
            return;
        } else {
            this.snackbarText = "";
            this.snackbarActive = false;
        }
        if (this.profile.configuration.accountingRule.write) {
            const rules = this.specs.rules;
            rules.accountableAccount = this.addAccountableAccount()
                ? this.specs.rules.accountableAccount
                : null;
            rules.thirdPartyAccountableAccount = this.addThirdPartyAccountableAccount()
                ? this.specs.rules.thirdPartyAccountableAccount
                : null;

            if (this.scopeManager) {
                await this.scopeManager.createScopeForClient();
            }

            await this.$apollo.mutate({
                mutation: gql`
                    mutation UpsertBankTransactionWordingPattern(
                        $id: ID
                        $name: String!
                        $patternSpec: Json!
                        $pattern: String!
                        $minAmount: Float
                        $maxAmount: Float
                        $rules: Json
                        $createThirdPartyCompany: CompanyCreateOneInput
                        $createThirdPartyUser: UserCreateOneInput
                        $updateThirdPartyCompany: CompanyUpdateOneInput
                        $updateThirdPartyUser: UserUpdateOneInput
                        $companyScopeId: ID!
                    ) {
                        upsertBankTransactionWordingPattern(
                            where: { id: $id }
                            create: {
                                name: $name
                                patternSpec: $patternSpec
                                pattern: $pattern
                                minAmount: $minAmount
                                maxAmount: $maxAmount
                                rules: $rules
                                thirdPartyCompany: $createThirdPartyCompany
                                thirdPartyUser: $createThirdPartyUser
                                companyScope: { connect: { id: $companyScopeId } }
                            }
                            update: {
                                name: $name
                                patternSpec: $patternSpec
                                pattern: $pattern
                                minAmount: $minAmount
                                maxAmount: $maxAmount
                                rules: $rules
                                thirdPartyCompany: $updateThirdPartyCompany
                                thirdPartyUser: $updateThirdPartyUser
                                companyScope: { connect: { id: $companyScopeId } }
                            }
                        ) {
                            id
                            pattern
                        }
                    }
                `,
                variables: {
                    id: this.patternId,
                    name: this.name,
                    patternSpec: this.specs.patternSpec,
                    pattern: this.regExGenerated,
                    minAmount: this.defineMinAmount ? Number(this.minAmount) : null,
                    maxAmount: this.defineMaxAmount ? Number(this.maxAmount) : null,

                    createThirdPartyCompany: this.addThirdPartyCompany
                        ? { connect: { id: this.specs.thirdPartyCompany.id } }
                        : undefined,
                    updateThirdPartyCompany: this.addThirdPartyCompany
                        ? { connect: { id: this.specs.thirdPartyCompany.id } }
                        : this.initialSpecs?.thirdPartyCompany
                          ? { disconnect: true }
                          : undefined,
                    createThirdPartyUser: this.addThirdPartyUser
                        ? { connect: { id: this.specs.thirdPartyUser.id } }
                        : undefined,
                    updateThirdPartyUser: this.addThirdPartyUser
                        ? { connect: { id: this.specs.thirdPartyUser.id } }
                        : this.initialSpecs?.thirdPartyUser
                          ? { disconnect: true }
                          : undefined,

                    rules,
                    companyScopeId: this.scopeId,
                },
            });
            // this.$emit("upserted")
            this.$router.go(-1);
        }
    }

    toggleRule(ruleName: string) {
        const isTurningOn = !this.specs.rules[ruleName];

        switch (ruleName) {
            case "thirdPartyOnly":
                if (isTurningOn) {
                    this.specs.rules.withoutInvoice = false;
                    this.specs.rules.withoutInvoiceWithThirdParty = false;
                    this.specs.rules.salesInvoiceAuto = false;
                    this.specs.rules.zTillReceipt = false;

                    this.resetAccountableAccount();
                    this.resetThirdPartyCompany();
                    this.resetThirdPartyUser();
                } else {
                    this.resetThirdPartyAccountableAccount();
                }
                break;

            case "withoutInvoice":
                if (isTurningOn) {
                    this.specs.rules.thirdPartyOnly = false;
                    this.specs.rules.withoutInvoiceWithThirdParty = false;
                    this.specs.rules.salesInvoiceAuto = false;
                    this.specs.rules.zTillReceipt = false;

                    this.resetAccountableAccount();
                    this.resetThirdPartyAccountableAccount();
                    this.resetThirdPartyCompany();
                    this.resetThirdPartyUser();
                }
                break;

            case "withoutInvoiceWithThirdParty":
                if (isTurningOn) {
                    this.specs.rules.thirdPartyOnly = false;
                    this.specs.rules.withoutInvoice = false;
                    this.specs.rules.salesInvoiceAuto = false;
                    this.specs.rules.zTillReceipt = false;
                    this.resetAccountableAccount();
                    this.resetThirdPartyAccountableAccount();
                    this.resetThirdPartyCompany();
                    this.resetThirdPartyUser();
                }
                break;

            case "salesInvoiceAuto":
                if (isTurningOn) {
                    this.specs.rules.thirdPartyOnly = false;
                    this.specs.rules.withoutInvoice = false;
                    this.specs.rules.withoutInvoiceWithThirdParty = false;
                    this.specs.rules.zTillReceipt = false;
                    this.resetAccountableAccount();
                    this.resetThirdPartyAccountableAccount();
                    this.resetThirdPartyCompany();
                    this.resetThirdPartyUser();
                }
                break;

            case "ztillReceipt":
                if (isTurningOn) {
                    this.specs.rules.thirdPartyOnly = false;
                    this.specs.rules.withoutInvoice = false;
                    this.specs.rules.withoutInvoiceWithThirdParty = false;
                    this.specs.rules.salesInvoiceAuto = false;
                    this.resetAccountableAccount();
                    this.resetThirdPartyAccountableAccount();
                    this.resetThirdPartyCompany();
                    this.resetThirdPartyUser();
                }
                break;

            default:
                console.warn(`Switch "${ruleName}" no contemplado en la lógica`);
                break;
        }
    }

    companySelected(company) {
        this.specs.thirdPartyCompany = company;
        this.dialogSelectCompany = false;
    }

    isReadOnly(accountingCompany, accountingCompanyOwner) {
        // if modified also change isReadOnly used with other components using <Scope>
        if (accountingCompany == null && accountingCompanyOwner?.id !== this.accountingCompanyId) {
            this.readonlyTemporaire = true;
        }
    }

    @Apollo({
        query: DEFAULT_ACCOUNTABLE_ACCOUNTS,

        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.defaultAccountableAccounts?.accountableAccounts) {
                    this.defaultAccountableAccounts = Object.values(
                        data.defaultAccountableAccounts.accountableAccounts,
                    );
                }
            }
        },
    })
    defaultAccountableAccounts = [];

    @Apollo({
        query: COMPANY_ACCOUNTABLE_ACCOUNT_TABLE,
        fetchPolicy: "network-only",
        variables() {
            return {
                companyId: this.uniqueAssignedCompanyId,
            };
        },
        skip() {
            return !this.uniqueAssignedCompanyId;
        },

        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.companyAccountableAccountTable) {
                    this.companyAccountableAccountTable = data.companyAccountableAccountTable;
                } else {
                    this.companyAccountableAccountTable = null;
                }
            }
        },
    })
    companyAccountableAccountTable = null;

    @Watch("uniqueAssignedCompanyId")
    onUniqueAssignedCompanyIdChanged() {
        this.companyAccountableAccountTable = null;
    }

    get currentAccountableAccounts() {
        if (this.uniqueAssignedCompanyId) {
            return this.companyAccountableAccountTable?.accountableAccounts || [];
        }
        return this.defaultAccountableAccounts;
    }

    get purchaseAndSalesAAs() {
        return this.currentAccountableAccounts.filter(
            (aa) => aa.name && (aa.name.startsWith("6") || aa.name.startsWith("7")),
        );
    }

    salesAANames = ["701000", "702000", "704000", "705000", "706000", "707000", "708000"];

    get salesAAs() {
        return this.currentAccountableAccounts.filter(
            (aa) => this.salesAANames.indexOf(aa.name) !== -1,
        );
    }

    CFSTF = ["Capital", "FixedAssets", "Stocks", "ThirdParty", "Financial"];

    get accountableAccountsCFSTF() {
        return this.currentAccountableAccounts.filter((aa) => this.CFSTF.indexOf(aa.type) !== -1);
    }
    // :inAccountableAccountType="'SelectedTypes'"
    //                         :inAccountableAccountTypes=""
    //                         :inAccountableAccounts=""

    @Apollo({
        query: BANK_WORDING_PATTERN,
        variables() {
            return {
                id: this.patternId,
            };
        },
        skip() {
            return !this.patternId || !this.profile.configuration.accountingRule.read;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    // let vat = this.vats[0]
                    // if(data.bankTransactionWordingPattern.vatRate || data.bankTransactionWordingPattern.vatType) {
                    //     vatRate = this.vats.find(e => e.vatRate === data.bankTransactionWordingPattern.vatRate && e.vatType === data.bankTransactionWordingPattern.vatType)
                    // }
                    // console.log(data.bankTransactionWordingPattern.taxSystems)
                    const specs = data.bankTransactionWordingPattern;

                    this.initialSpecs = JSON.parse(JSON.stringify(specs));
                    //

                    // migration
                    const prevPatternSpec = data.bankTransactionWordingPattern.patternSpec;
                    if (prevPatternSpec?.length && prevPatternSpec[0].length) {
                        specs.patternSpec = [];
                        for (const spec of prevPatternSpec) {
                            specs.patternSpec.push({
                                operator: "equal",
                                words: spec,
                            });
                        }
                    }
                    // end migration

                    if (!this.specs.thirdPartyCompany) {
                        this.resetThirdPartyCompany(specs);
                    }
                    if (!this.specs.thirdPartyUser) {
                        this.resetThirdPartyUser(specs);
                    }

                    if (!specs.rules) {
                        specs.rules = {
                            accountableAccount: null,
                            thirdPartyAccountableAccount: null,
                            tags: [],

                            outputWording: "",
                            thirdPartyOnly: false,
                            withoutInvoice: false,
                            withoutInvoiceWithThirdParty: false,
                            salesInvoiceAuto: false,
                            zTillReceipt: false,

                            vatRate: null,
                            vatType: null,
                        };
                    }
                    this.specs = specs;

                    if (this.specs.vatRate || this.specs.vatType) {
                        const vat = this.vats.find(
                            (e) =>
                                e.vatRate === this.specs.vatRate &&
                                e.vatType === this.specs.vatType,
                        );
                        if (vat) {
                            this.vat = vat;
                        } else {
                            this.vat = null;
                        }
                    } else {
                        this.vat = null;
                    }
                    // let vat = this.vats[0]
                    // if(data.bankTransactionWordingPattern.vatRate || data.bankTransactionWordingPattern.vatType) {
                    //     vatRate = this.vats.find(e => e.vatRate === data.bankTransactionWordingPattern.vatRate && e.vatType === data.bankTransactionWordingPattern.vatType)
                    // }
                    //

                    this.minAmount = this.specs.minAmount !== null ? this.specs.minAmount : 0;
                    this.maxAmount = this.specs.maxAmount !== null ? this.specs.maxAmount : 0;
                    this.defineMinAmount = this.specs.minAmount !== null;
                    this.defineMaxAmount = this.specs.maxAmount !== null;

                    const scope = data.bankTransactionWordingPattern.companyScope;
                    if (scope) {
                        this.scopeId = scope?.id || "";
                        this.scopeName = scope?.name || "";
                        this.scopeSharingStatus = scope.scopeSharingStatus;
                        this.isReadOnly(scope.accountingCompany, scope.accountingCompanyOwner);

                        this.allAccountingCompany = !scope.accountingCompany;
                    } else {
                        this.scopeId = "";
                        this.scopeSharingStatus = "";
                        this.allAccountingCompany = true;
                    }
                }
                this.apolloFinished = true;
            }
        },
    })
    specs = {
        id: "",
        // startWith: [],
        patternSpec: [],
        // endWith: [],
        minAmount: null,
        maxAmount: null,
        // transactionType: "",
        accountableAccount: {
            id: "",
            name: "",
            subAccountableAccountOf: null,
        },

        thirdPartyAccountableAccount: {
            id: "",
            name: "",
            displayName: "",
            subAccountableAccountOf: null,
        },

        rules: {
            accountableAccount: null,
            thirdPartyAccountableAccount: null,
            tags: [],

            outputWording: "",
            thirdPartyOnly: false,
            withoutInvoice: false,
            withoutInvoiceWithThirdParty: false,
            salesInvoiceAuto: false,
            zTillReceipt: false,

            vatRate: null,
            vatType: null,
        },

        thirdPartyCompany: {
            id: "",
            name: "",
            parentCompany: null,
        },
        thirdParty: {
            id: "",
            type: "",
            name: "",
            firstname: "",
            lastname: "",
        },
        thirdPartyUser: {
            id: "",
            firstname: "",
            lastname: "",
        },
        company: "",
        tags: [],
    };

    async simulatingWordingBTAnalysis(pattern) {
        this.displaySimulationResult = true;
        this.simulationLoading = true;
        const result: any = await this.$apollo.query({
            query: gql`
                query SimulateWordingBTAnalysis($companyId: ID, $pattern: String!, $info: Json) {
                    simulateWordingBTAnalysis(
                        data: { companyId: $companyId, pattern: $pattern, info: $info }
                    ) {
                        id
                        amount
                        wordingDisplay
                        wordingOriginal
                        dateDebit
                    }
                }
            `,
            variables: {
                companyId: this.scopedCompanyId,
                pattern: this.regExGenerated,
                info: {
                    minAmount: this.defineMinAmount ? this.minAmount : undefined,
                    maxAmount: this.defineMaxAmount ? this.maxAmount : undefined,
                },
            },
        });
        if (result && result.data && result.data.simulateWordingBTAnalysis) {
            const temporary = [];
            // for(const bt of result.data.simulateWordingBTAnalysis){
            //     temporary.push(bt)
            //     temporary.slice(-1)[0].dateDebit = moment(date).format('DD/MM/YYYY')
            // }
            this.simulateWordingBTAnalysis = result.data.simulateWordingBTAnalysis;
            this.simulationLoading = false;
        } else {
            this.simulateWordingBTAnalysis = [];
        }
    }

    simulateWordingBTAnalysis = [];

    get formatedSimulateWordingBTAnalysis() {
        const result = [];
        for (const bt of this.simulateWordingBTAnalysis) {
            result.push({
                wordingDisplay: bt.wordingDisplay,
                wordingOriginal: bt.wordingOriginal,
                amount: bt.amount,
                date: moment(bt.dateDebit).format("DD/MM/YYYY"),
            });
        }
        return result;
    }

    async applyingSimulation(allScopeSimulationChoices = false) {
        this.applySimulationDialogLoading = true;
        const companyIds = [];
        if (allScopeSimulationChoices) {
            for (const company of this.scopedCompanies) {
                companyIds.push(company.id);
            }
        } else if (this.scopedCompanyId) {
            companyIds.push(this.scopedCompanyId);
        }
        if (companyIds.length) {
            const result: any = await this.$apollo.query({
                query: gql`
                    query ApplySimulationWordingBTAnalysis(
                        $companyIds: [ID!]
                        $pattern: Json!
                        $info: Json
                    ) {
                        applySimulationWordingBTAnalysis(
                            data: { companyIds: $companyIds, pattern: $pattern, info: $info }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    companyIds: companyIds,
                    pattern: {
                        id: this.patternId,
                        name: this.name,
                        patternSpec: this.specs.patternSpec,
                        pattern: this.regExGenerated,
                        thirdPartyCompany: this.addThirdPartyCompany
                            ? this.specs.thirdPartyCompany
                            : undefined,
                        thirdPartyUser: this.addThirdPartyUser
                            ? this.specs.thirdPartyUser
                            : undefined,
                        rules: this.specs.rules,
                    },
                    info: {
                        minAmount: this.defineMinAmount ? this.minAmount : undefined,
                        maxAmount: this.defineMaxAmount ? this.maxAmount : undefined,
                    },
                },
            });
            if (result && result.data) {
                this.applySimulationDialogLoading = false;
                this.applySimulationDialog = false;
                this.applyOnCompaniesDialog = false;
                this.alertApplyingSimulationSuccess = true;
            }
        }
    }

    addAccountableAccount() {
        if (
            (this.specs.rules.withoutInvoice ||
                this.specs.rules.withoutInvoiceWithThirdParty ||
                this.specs.rules.salesInvoiceAuto) &&
            this.specs.rules?.accountableAccount.name
        ) {
            return true;
        }
        return false;
    }

    addThirdPartyAccountableAccount() {
        if (this.specs.rules.withoutInvoice) {
            return false;
        }
        if (this.specs.rules.zTillReceipt) {
            return false;
        }
        if (this.specs.rules.salesInvoiceAuto) {
            return false;
        }
        if (this.specs.rules.withoutInvoiceWithThirdParty) {
            return false;
        }
        if (
            this.specs.rules?.thirdPartyAccountableAccount &&
            this.specs.rules.thirdPartyAccountableAccount.name
        ) {
            // if(!this.thirdPartyCompanyIsRequired && this.specs.rules.thirdPartyAccountableAccount.thirdPartyCompany) {
            //     return false
            // }
            // if(!this.thirdPartyUserIsRequired && this.specs.rules.thirdPartyAccountableAccount.user) {
            //     return false
            // }
            return true;
        }
        return false;
    }

    get addThirdPartyCompany() {
        if (this.specs.rules.withoutInvoice) {
            return false;
        }
        if (this.specs.rules.zTillReceipt) {
            return false;
        }
        if (this.specs.rules.salesInvoiceAuto) {
            return false;
        }
        if (this.thirdPartyCompanyIsRequired && this.specs.thirdPartyCompany?.id) {
            return true;
        }
        return false;
    }

    get addThirdPartyUser() {
        if (this.specs.rules.withoutInvoice) {
            return false;
        }
        if (this.specs.rules.zTillReceipt) {
            return false;
        }
        if (this.specs.rules.salesInvoiceAuto) {
            return false;
        }
        if (this.thirdPartyUserIsRequired && this.specs.thirdPartyUser?.id) {
            return true;
        }
        return false;
    }
    userHasBeenWarned = false;
    areYouSureDialog = false;
    warnUser() {
        if (!this.userHasBeenWarned && !this.leBoutton.disabled) {
            this.areYouSureDialog = true;
            this.userHasBeenWarned = false;
        } else {
            this.areYouSureDialog = false;
            this.$router.go(-1);
        }
    }

    onNoDialog() {
        this.areYouSureDialog = false;
        this.userHasBeenWarned = false;
    }
    onYesDialog() {
        this.userHasBeenWarned = true;
        this.$router.go(-1);
    }

    @Watch("defineMinAmount")
    setMinAmount() {
        if (this.defineMinAmount) {
            this.specs.minAmount = this.minAmount;
        } else {
            this.specs.minAmount = null;
        }
    }

    @Watch("defineMaxAmount")
    setMaxAmount() {
        if (this.defineMaxAmount) {
            this.specs.maxAmount = this.maxAmount;
        } else {
            this.specs.maxAmount = null;
        }
    }

    @Watch("scopedCompanies")
    setScopeSimulationIfUniqueChoice() {
        //also set specs.thirdParty if thirdParty is not global
        if (this.scopedCompanies?.length === 1) {
            this.scopedCompanyId = this.scopedCompanies[0].id;
        } else if (this.scopedCompanyId) {
            if (
                !this.scopedCompanies?.length ||
                !this.scopedCompanies.find((e) => e.id === this.scopedCompanyId)
            ) {
                // includes doesn't work
                this.scopedCompanyId = null;
            }
        }
    }

    @Watch("scopedCompanyId")
    setDisplaySimulation() {
        this.displaySimulationResult = false;
    }

    addCondition() {
        this.specs.patternSpec.push({ operator: "equal", words: [] });
    }

    // validationBobbee() {
    //     this.validationForAllAccountingCompany = true
    //     this.upload()
    // }

    // devalidationBobbee() {
    //     this.validationForAllAccountingCompany = false
    //     this.upload()
    // }

    get thirdPartyTitle() {
        if (this.specs.thirdPartyCompany?.name) {
            return this.specs.thirdPartyCompany.name;
        }
        if (this.specs.thirdPartyUser?.id) {
            return getUserDisplayName(this.specs.thirdPartyUser);
        }
        return "";
    }

    onScopedCompaniesChanged(companies) {
        this.scopedCompanies = companies;
    }
}

export default toNative(WordingAnalysisEdition);
</script>

<style>
.sticky-card {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1000;
}
.scrolled-card {
    margin-top: 2vh;
    padding: 20px;
    border-radius: 16px;
    margin-top: 8px;
    margin-bottom: 8px;
}
</style>
